// @ts-ignore
import store from '../../../../../../store';
import {Sprite} from 'pixi.js';
import {TableStacks} from './table_objects/TableStacks';
import {NewPixiSceneEvents} from '../../../events/NewPixiSceneEvents';
import {StaticData} from '../../../data/StaticData';
import {DynamicData} from '../../../data/DynamicData';
import {TableObjectsEvents} from './table_objects/TableObjectsEvents';
import VideoPlaceholders from './table_objects/VideoPlaceholders';

export class TableObjects extends Sprite
{
    stacks: TableStacks = new TableStacks();
    videoPlaceholders: VideoPlaceholders | undefined;
    private onPlayersUpdatedBindThis: (e: Event) => void;

    constructor() {
        super();

        this.onPlayersUpdatedBindThis = this.onPlayersUpdated.bind(this);

        if (!StaticData.isAdmin) {
            addEventListener(NewPixiSceneEvents.PLAYERS_UPDATED, this.onPlayersUpdatedBindThis);
            this.onPlayersUpdated();
        }
    }

    /**
     * Загрузка и установка объектов игрого поля
     */
    async initialize(): Promise<void> {
        await this.stacks.initialize();
        this.addChildAt(this.stacks, 0);

        this.tryRemoveVideoPlaceHolders();
        this.tryAddVideoPlaceholders();
    }

    tryAddVideoPlaceholders(): void {
        if (this.videoPlaceholders) {
            return;
        }
        let gameState = store.getters.getGameState;
        if (gameState.tasks?.state?.activity?.settings?.layoutType == 5) {
            this.videoPlaceholders = new VideoPlaceholders();
            this.addChildAt(this.videoPlaceholders, 1);
            this.videoPlaceholders.setPlayersData(gameState.playersData);
        }
    }

    /**
     * Уничтожение
     */
    destroy(): void {
        this.tryRemoveVideoPlaceHolders();
        removeEventListener(NewPixiSceneEvents.PLAYERS_UPDATED, this.onPlayersUpdatedBindThis);

        delete this.onPlayersUpdatedBindThis;

        super.destroy({children: true});
    }

    tryRemoveVideoPlaceHolders(): void {
        if (this.videoPlaceholders) {
            this.videoPlaceholders.destroy();
            this.removeChild(this.videoPlaceholders);
            this.videoPlaceholders = undefined;
        }
    }

    private onPlayersUpdated(e?: Event): void {
        e;
        this.interactive = this.interactiveChildren = !DynamicData.players.find(player => player.id == StaticData.playerId)!.isGuest;
        dispatchEvent(new MessageEvent(TableObjectsEvents.UPDATED));
    }
}
